import { List, Columns3 } from "lucide-react";

export const ViewToggle = ({ value, onChange, testidPrefix = "task-view" }) => (
  <div className="inline-flex rounded-full border border-[#5FB3EA] bg-[#A6DAFC] p-1">
    {[["elenco", "Elenco", List], ["bacheca", "Bacheca", Columns3]].map(([k, l, I]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testidPrefix}-${k}`}
        className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${value === k ? "bg-[#0A1128] text-white" : "text-[#0A1128] hover:bg-[#8FD0FB]"}`}>
        <I className="h-4 w-4" />{l}
      </button>
    ))}
  </div>
);
